// export class CustomerSiteContact {
//     contactid: number;
//     customersitecode: string;
//     contacttype: string;
//     contactperson: string;
//     designation: string;
//     department: string;
//     phoneno: string;
//     mobileno: string;
//     emailid: string;
//     faxno: string;
// }

export class CustomerSiteContact {
    contactid: number;
    customersitecode: string;
    contacttypecode: string;
    contacttype: string;
    contactperson: string;
    designation: string;
    department: string;
    phoneno: string;
    mobileno: string;
    emailid: string;
    faxno: string;
    recordstatuscode: string;
    recordstatus: string;
}